// removed by extract-text-webpack-plugin
module.exports = {"scroll-to-top":"scroll-to-top___2kaBY","red":"red___Y6lfp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ScrollToTop/ScrollToTop.css
// module id = 891
// module chunks = 0